<template>
	<JBox class="s-p-4">
		<!-- Internal stuff -->
		<JBox class="s-flex s-flex-wrap s-pb-6">
			<!-- ID -->
			<JBox class="s-w-wull s-mb-8">
				<JBox class="s-font-semibold s-text-xs s-uppercase s-text-gray-600">
					{{ $t("uiEditor.elementID") }}
				</JBox>
				<JBox class="s-inline s-bg-purple-200 s-text-purple-900 s-p-1 s-px-2 s-text-xs s-font-semibold s-rounded  s-uppercase">
					{{ internalNode.id }}
				</JBox>
			</JBox>
			<JBox class="s-w-full">
				<JBox class="s-font-semibold s-text-xs s-uppercase s-text-gray-600">
					{{ $t("uiEditor.elementLabel") }}
				</JBox>
				<!-- <j-input-text v-model="internalNode.label" /> -->
				<JBox class="s-inline s-bg-gray-300  s-text-black s-p-1 s-px-2 s-text-xs s-font-semibold s-rounded s-uppercase">
					{{ internalNode.component }}
				</JBox>
			</JBox>
		</JBox>

		<!-- Content -->
		<template>
			<JBox class="s-mt-6 s-font-semibold s-text-xs s-uppercase s-text-gray-600">
				{{ $t("uiEditor.content") }}
			</JBox>
			<JInputLongText :rows="4" v-model="internalNode.content" @input="putNode" />

			<!-- Localization -->
			<JBox class="s-mt-4 s-font-semibold s-text-xs s-uppercase s-text-gray-600">
				Localization
			</JBox>
			<InspectorLocalization />
		</template>

		<!-- Delete -->
		<JBox class="s-w-full s-mt-32">
			<JBox
				@click="$store.dispatch('uiEditor/deleteNode', internalNode)"
				class="s-w-full s-p-2 s-bg-red-100 s-border s-border-red-500 s-text-red-500 s-rounded s-uppercase s-text-sm s-text-center s-font-semibold s-cursor-pointer"
			>
				Delete Element
			</JBox>
		</JBox>
	</JBox>
</template>

<script>
import InspectorLocalization from "./InspectorLocalization"
import debounce from "lodash.debounce"

export default {
	components: { InspectorLocalization },

	data() {
		return {
			internalNode: {}
		}
	},

	methods: {
		putNode: debounce(function() {
			this.$store.dispatch("uiEditor/putNode", this.internalNode)
		}, 150)
	},

	watch: {
		"$store.state.uiEditor.selectedNodeIds": {
			handler() {
				this.internalNode = this.$store.getters["uiEditor/selectedNode"]
			},
			deep: true,
			immediate: true
		}
	}
}
</script>
